/**
 * A non-breaking hyphen. Looks like a normal hyphen, but the browser won't line
 * break at it. Useful for stuff like "1-on-1s" that would look awkward if broken.
 * @see https://codepoints.net/U+2011
 */
export const NON_BREAKING_HYPHEN = "\u2011";

// Often, it can be simpler to use a Unicode space of a particular width to space
// out inline elements, rather than adding margin/padding with CSS. It scales
// with font size, and doesn't require additional CSS rules.
// For examples of Unicode spaces, see: https://jkorpela.fi/chars/spaces.html
//
// Some Unicode spaces are available as HTML entities:
// • &emsp; - em space, 1em wide, U+2003
// • &ensp; - en space, 1en (0.5em) wide, U+2002
// • &nbsp; - non-breaking space, normal space width, U+00A0

/**
 * A three-per-em space, i.e. ⅓ the width of an em.
 *
 * a.k.a. "thick space"
 * @see https://codepoints.net/U+2004
 */
export const THREE_PER_EM_SPACE = "\u2004";
